import { useFollowing } from "@serophin/nottldr-shared/hooks";
import { Loader2, UserCheck, UserPlus } from "lucide-preact";
import { useState } from "preact/hooks";
import { useToast } from "../../contexts/ToastContext";

/** The round follow / unfollow button on an author card. */
export const FollowButton = ({ alias }: { alias: string }) => {
  const { isFollowing, follow, unfollow } = useFollowing();
  const [isUpdating, setIsUpdating] = useState(false);
  const toast = useToast();
  const following = isFollowing(alias);

  const handleClick = async (event: MouseEvent) => {
    event.preventDefault();
    if (isUpdating) {
      return;
    }
    setIsUpdating(true);
    try {
      await (following ? unfollow(alias) : follow(alias));
    } catch {
      toast.error("Failed to update follow status. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isUpdating}
      class={`p-2 rounded-full transition-colors ${isUpdating ? "opacity-50 cursor-not-allowed" : ""} bg-black/50 hover:bg-black/75 backdrop-blur-sm`}
      aria-label={following ? "Unfollow" : "Follow"}
    >
      {isUpdating ? (
        <Loader2 size={16} class="animate-spin text-white" />
      ) : following ? (
        <UserCheck size={16} class="text-white" fill="currentColor" />
      ) : (
        <UserPlus size={16} class="text-white" />
      )}
    </button>
  );
};
